import "./style.css";
import type { ComponentType } from "react";
import { useNavigate } from "react-router-dom";

import { ROLES } from "../../common/enums";
import { desctopMenuLinks } from "./desctopMenuLinks";
import BurgerMenu from "./BurgerMenu";

import {
  selectMainState,
  setFeedbackModal,
  setSEOSettings,
} from "../../store/slices/main";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";

import DesctopHeaderPlayer from "./headerPlayer/desctopHeaderPlayer/DesctopHeaderPlayer";
import LogoDesctop from "../../assets/icon/LogoDesctop";

type MenuIcon = string | ComponentType<any> | undefined;

function MenuIconView({ icon, alt }: { icon: MenuIcon; alt: string }) {
  if (!icon) return null;

  if (typeof icon === "string") {
    return <img src={icon} alt={alt} className="w-5 h-5 shrink-0" />;
  }

  // React-компонент (например ShopButton)
  const IconComponent = icon;
  return <IconComponent aria-label={alt} className="w-5 h-5 shrink-0" />;
}

export default function Header() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { SEOSettingsDefault } = useAppSelector(selectMainState);

  const role = ROLES.ADMIN;

  const navigateAndSetSEOSettings = (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string,
  ) => {
    navigate(link);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      }),
    );
  };

  const menu = Object.values(desctopMenuLinks[role] ?? {});

  return (
    <>
      <div className="md:hidden flex justify-center items-center w-screen h-[9.4rem] z-50">
        <BurgerMenu />
      </div>

      <div className="DESKTOP-MENU hidden md:block w-full md:max-w-[1000px] h-[7.25rem]">
        <div className="flex w-full h-full justify-between items-center rounded-md">
          <div className="w-full h-auto flex justify-start items-center">
            <div
              onClick={() => {
                if (SEOSettingsDefault) {
                  navigateAndSetSEOSettings(
                    "/",
                    SEOSettingsDefault.appTitle,
                    SEOSettingsDefault.appDescription,
                    "",
                  );
                } else {
                  navigate("/");
                }
              }}
              className="w-full max-w-[7rem] h-auto flex justify-center items-center lg:mr-[2rem] cursor-pointer"
            >
              {SEOSettingsDefault?.headerImg ? (
                <img src={SEOSettingsDefault.headerImg} alt="logo" />
              ) : (
                <LogoDesctop />
              )}
            </div>

            <nav className="flex items-center">
              <ul className="sm:flex items-center">
                {menu.map(({ title, path, icon }) => {
                  const isExternal = /^https?:\/\//i.test(path);

                  return (
                    <li
                      key={title}
                      className="flex flex-row items-center h-11 lg:pr-3"
                    >
                      {isExternal ? (
                        <a
                          href={path}
                          target="_blank"
                          rel="noreferrer"
                          className="rounded-md px-[8px] py-[6px] text-sm font-semibold tracking-wide truncate hover:bg-black hover:bg-opacity-[4%] transition-all duration-100 flex items-center gap-2"
                        >
                          <span>{title}</span>
                          <MenuIconView icon={icon} alt={title} />
                        </a>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            if (path === "/contacts") {
                              dispatch(setFeedbackModal(true));
                            } else if (SEOSettingsDefault) {
                              navigateAndSetSEOSettings(path, title, title, "");
                            } else {
                              navigate(path);
                            }
                          }}
                          className="rounded-md px-[8px] py-[6px] text-sm font-semibold tracking-wide truncate hover:bg-black hover:bg-opacity-[4%] transition-all duration-100 flex items-center gap-2"
                        >
                          <span>{title}</span>
                          <MenuIconView icon={icon} alt={title} />
                        </button>
                      )}
                    </li>
                  );
                })}
              </ul>
            </nav>
          </div>

          <div className="w-full min-w-[15rem] max-w-[21.6rem]">
            <DesctopHeaderPlayer />
          </div>
        </div>
      </div>
    </>
  );
}
